import React, { useCallback, useState } from 'react'
import { useDropzone } from 'react-dropzone'

import './styles.scss'
import { isImage } from 'utils/Validations'
import { fileReader } from 'utils/FileUtils'
import { hasImgRightDimensions } from 'utils/ImageUtils'
import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'

export default function Dropzone(props) {
  const { multiple } = props
  const [messageError, setMessageError] = useState(null)

  const filePreview = async (files) => {
    if (!files.length) return null

    const filesAccepted = []

    for (const currentFile of files) {
      let file = {
        path: currentFile.path,
        name: currentFile.name,
        preview: currentFile.preview,
        size: currentFile.size,
        lastModified: currentFile.lastModified,
        file: currentFile,
      }

      const result = await fileReader(currentFile)
      file.preview = result

      filesAccepted.push(file)
    }

    props.handleDrop(filesAccepted)
  }

  const handleOnDrop = useCallback(async (acceptedFiles, rejectedFiles) => {
    setMessageError(null)

    // Only for file preview
    if (props.dimensions || props.imgTotalDimensions10000px) {
      for (const file of acceptedFiles) {
        if (isImage(file.type)) {
          const isPassed = await hasImgRightDimensions(
            file,
            {
              allowDimensions: props.dimensions || {},
              isTotalDimensions10Kpx: props.imgTotalDimensions10000px
            }
          )

          if (!isPassed.isOk) {
            return setMessageError(
              isPassed.message
                ? lang(isPassed.message)
                : props.messageErrorDimensions || ''
            )
          }
        }
      }

      filePreview(acceptedFiles)
    } else {
      filePreview(acceptedFiles)
    }

    rejectedFiles.forEach((file) => {
      if (props.maxSize > 0) {
        if (file.size > props.maxSize) return setMessageError(props.messageErrorSize)
      }
    })
  }, [props])

  const { getRootProps, getInputProps } = useDropzone({ ...props, onDrop: handleOnDrop })
  // const { ref, tabIndex, onBlur, onClick, onDragEnter, onDragLeave, onDragOver, onDrop, onFocus, onKeyDown } = getRootProps()

  return (
    <div
      className='dropzone'
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <p
        className='dropzone__text'
        dangerouslySetInnerHTML={{
          __html: props.labelSize || lang(multiple ? 'placeholder_default_max_files_size' : 'placeholder_default_max_file_size')
        }}
      />
      <button
        type='button'
        className='dropzone__btn'
        // onClick={onClick}
      >
        <figure>
          <img src={getStaticImage('/icons/orange-brand/icon-upload-cloud-grey.svg')} alt='Upload' />
        </figure>
        {lang(multiple ? 'dashboard_add-files' : 'dashboard_add-file')}
      </button>
      {messageError ? (
        <p className='dropzone__text dropzone__text--error'>{messageError}</p>
      ) : null}
    </div>
  )
}
